<template>
  <v-layout justify-center>
    <v-fab-transition>
      <v-btn
        v-show="showFab"
        class="mx-2"
        fab
        dark
        large
        fixed
        :bottom="true"
        :right="true"
        color="primary"
        @click="toTop()"
      >
        <v-icon dark> mdi-chevron-up </v-icon>
      </v-btn>
    </v-fab-transition>
    <v-container align="center" justify="center">
      <v-row align="center" justify="center">
        <v-col cols="12">
          <balance-viewer
            ref="balanceViewer"
            :selectedClient="selectedClient"
            :defaultCurrency="defaultCurrency"
            :addresses="addresses"
            @togglePrint="togglePrint"
          />
        </v-col>
      </v-row>

      <v-row align="center" justify="center">
        <v-col cols="12">
          <ledger-data-table
            ref="ledgerDataTable"
            :selectedClient="selectedClient"
            :defaultCurrency="defaultCurrency"
            :addresses="addresses"
            :docTypes="docTypes"
          />
        </v-col>
      </v-row>
    </v-container>

    <print-dialog
      ref="printDialog"
      :docTypes="docTypes"
      :selectedClient="selectedClient"
      :printFile="printFile"
      :addresses="addresses"
      :defaultCurrency="defaultCurrency"
      @togglePrint="togglePrint"
    />

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import ServiceLedger from "@/services/ServiceLedger";
import ServiceClient from "@/services/ServiceClient";
import ServiceCurrency from "@/services/ServiceCurrency";
import ServiceDocTypes from "@/services/ServiceDocTypes";

import debounce from "lodash/debounce";

import axios from 'axios'

import BalanceViewer from "./common/BalanceViewer";
import LedgerDataTable from "./common/LedgerDataTable.vue";
import PrintDialog from "./common/PrintDialog.vue";

export default {
  name: "ledger-List",
  components: {
    BalanceViewer,
    LedgerDataTable,
    PrintDialog,
  },
  data: () => ({
    selectedClient: {name: 'client'},
    defaultCurrency: "",
    overlay: false,
    printFile: null,
    showFab: false,
    addresses: [],
    docTypes: [],
    showDefaultCurrency: false
  }),
  methods: {
    handleScroll() {
      this.showFab = window.scrollY > 150;
    },
    toTop() {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: "smooth",
      });
    },
    togglePrint() {
      this.$refs.printDialog.toggle();
    },
  },
  async mounted() {
    this.overlay = true;

    try {
    let url = process.env.VUE_APP_API_URL + "/files/print.html";
      const results = await Promise.all([
        ServiceClient.getAddresses(),
        ServiceLedger.getBalance(this.balanceAddressId),
        ServiceCurrency.get(),
        ServiceDocTypes.get(),
        axios({
    url,
    method: 'GET',
    responseType: 'text'
  }),
        ServiceLedger.getLedger(1, null, null, null, null, null, null),
      ]);

      this.addresses = results[0].data;
      this.addresses.unshift({
        id: null,
        value: "Todas",
      });

      this.$refs.balanceViewer.setCurrentBalance(results[1].data);

      this.defaultCurrency = results[2].data.value;

      this.docTypes = results[3].data;

      this.printFile = results[4].data;

      this.$refs.ledgerDataTable.setValues(results[5].data, false);

      this.handleDebouncedScroll = debounce(this.handleScroll, 100);
      window.addEventListener("scroll", this.handleDebouncedScroll);
    } catch (error) {
      this.$store.dispatch("setSnackbar", {
        color: "error",
        text: error,
      });
    }

    this.overlay = false;
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.handleDebouncedScroll);
  },
};
</script>
<style>
.rowBad {
  background-color: rgba(255, 0, 0, 0.3);
}
</style>
